import { EvaluationCriterionFieldsFragment } from "@/graphql";

import { EvaluationCriteriaCardRich } from "./EvaluationCriteriaCardRich";
import { EvaluationCriteriaCardSimple } from "./EvaluationCriteriaCardSimple";

export type ViewMode = "simple" | "detailed" | "edit";

export interface EvaluationCriteriaCardProps {
  criterion: EvaluationCriterionFieldsFragment;
  viewMode: ViewMode;
  refetch: () => void;
  entityType: "scenario" | "rubric";
  scenarioId?: string;
  rubricId?: string;
}

export function EvaluationCriteriaCard(props: EvaluationCriteriaCardProps) {
  const { viewMode, criterion, refetch } = props;

  if (viewMode === "simple") {
    return <EvaluationCriteriaCardSimple criterion={criterion} />;
  }

  // For detailed and edit views, use the rich card
  const richProps = {
    criterion,
    canEdit: viewMode === "edit",
    refetch,
    entityType: props.entityType,
    ...(props.entityType === "scenario" && { scenarioId: props.scenarioId }),
    ...(props.entityType === "rubric" && { rubricId: props.rubricId }),
  };

  return <EvaluationCriteriaCardRich {...richProps} />;
}
